import { TableCell as MuiTableCell, TableCellProps } from "@mui/material";
import React from "react";

function TableCell({ sx, ...props }: TableCellProps): React.JSX.Element {
  return <MuiTableCell sx={{ borderBottom: "none", ...sx }} {...props} />;
}

export default TableCell;
